import { create } from "zustand";
import { devtools } from "zustand/middleware";

export type ShellCreateDialog = "beneficiary" | "investor";

interface ShellCreateStoreState {
  dialog: ShellCreateDialog | null;
  open: (dialog: ShellCreateDialog) => void;
  close: () => void;
}

export const useShellCreateStore = create<ShellCreateStoreState>()(
  devtools(
    (set) => ({
      dialog: null,
      open: (dialog) => set({ dialog }),
      close: () => set({ dialog: null }),
    }),
    { name: "ShellCreateStore" },
  ),
);
